import styled from 'styled-components';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';

const StyledVideoPlayer = styled.div.attrs({
	className: 'fuse-video-player',
})``;

const StyledTextWrapper = styled.div.attrs({
	className: 'fuse-video-player__text-wrapper',
	'data-testid': 'fuse-video-player-text-wrapper',
})`
	gap: var(--spacing-global-space3);
	display: flex;
	flex-direction: column;
	margin-bottom: var(--spacing-global-space7);
`;

const StyledTitle = styled(TypographyComponent).attrs({
	className: 'fuse-video-player__title',
	'data-testid': 'fuse-video-player-title',
})`
	margin-bottom: 0;
`;

const StyledDescription = styled(TypographyComponent).attrs({
	className: 'fuse-video-player__video-description',
	'data-testid': 'fuse-video-player-video-description',
})`
	margin-bottom: 0;
`;

const StyledVideo = styled.video.attrs({
	className: 'fuse-video-player__video',
	'data-testid': 'fuse-video-player-video',
})`
	display: block;
	width: 100%;
	aspect-ratio: ${({ ratio }) => (ratio ? ratio.replace(':', '/') : '16/9')};
	cursor: pointer;

	&:focus {
		outline: unset;
	}

	&:focus-visible {
		outline: var(--spacing-global-space1) solid var(--color-functional-focus);
		outline-offset: var(--spacing-global-space1);
	}
`;

export { StyledVideoPlayer, StyledTextWrapper, StyledTitle, StyledDescription, StyledVideo };
